export default "__VITE_ASSET__BIPciUO7__"